<template>
  <el-dialog
    :visible="true"
    width="504px"
    :show-close="false"
    :close-on-click-modal="false"
    class="chartDia"
  >
    <div slot="title" class="slotTit">提现申请</div>
    <el-form ref="ruleForm" class="ruleForm" label-width="120px">
      <div class="colorBlock">
        提现信息：
      </div>
      <!-- <el-form-item label="提现流水号：">
        {{cashObj.orderNo}}
      </el-form-item> -->
      <el-form-item label="公司名称：">
        {{ cashObj.companyName }}
      </el-form-item>
      <el-form-item label="银行账号：">
        {{ cashObj.openBankNumber }}
      </el-form-item>
      <el-form-item label="开户行：">
        {{ cashObj.openBankName }}
      </el-form-item>
      <el-form-item label="提现金额：">
        <span style="color:#1989FA">{{ Number(cashObj.amount) }}</span>
        元
      </el-form-item>
      <el-form-item label="手续费：">{{ outFee_mixin }}元</el-form-item>
      <el-form-item label="实际到账金额：">
        <span style="color:#FAB119">
          {{ arrivalMoney }}
        </span>
        元
      </el-form-item>
      <div class="colorBlock">
        提现验证：
      </div>
      <el-form-item label="验证手机：">
        {{ cashObj.transactorPhone }}
      </el-form-item>
      <div class="flexBox" style="justify-content:flex-start;">
        <el-input
          v-model="code"
          placeholder="请输入短信验证码"
          style="width:200px;margin-left:30px;"
        ></el-input>
        <el-button
          type="primary"
          @click="send"
          :disabled="text != '获取验证码'"
        >
          {{ text }}
        </el-button>
      </div>
      <div style="margin-top:30px;display:flex;justify-content:space-around;">
        <el-button
          type="primary"
          @click="confirm"
          :disabled="code == ''"
          clearable
        >
          确认提现
        </el-button>
        <el-button type="primary" plain @click="cancel">返回</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
import { withdrawals } from '@/api/ajax';
import { getStorage } from '@/tools/storage';
import outFeeMixin from '@/Mixin/out-fee-mixin.js';
import { twoDecimal, moneyComplete } from '@/tools/money';

export default {
  mixins: [outFeeMixin],
  props: {
    cashObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      ruleForm: {
        cashNum: ''
      },
      text: '获取验证码',
      timer: null,
      code: '',
      user: getStorage('user')
    };
  },
  computed: {
    arrivalMoney() {
      return twoDecimal(
        moneyComplete(this.cashObj.amount) - moneyComplete(this.outFee_mixin),
        100
      );
    }
  },
  methods: {
    send() {
      //确认提现
      withdrawals
        .sendWithdrawalsMsg({
          payPassagewayCode: this.cashObj.payPassagewayCode
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: '发送成功，请注意查收'
          });
          this.text = 60;
          this.timer = setInterval(() => {
            if (this.text > 0) {
              this.text--;
            } else {
              this.text = '获取验证码';
              clearInterval(this.timer);
            }
          }, 1000);
        });

      // this.$parent.componentName = ''
    },
    confirm() {
      withdrawals
        .submitWithdrawals({
          verifyCode: this.code,
          id: this.cashObj.id,
          amount: moneyComplete(this.cashObj.amount),
          payPassagewayCode: this.cashObj.payPassagewayCode
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: '操作成功'
          });
          this.$parent.componentName = '';
        });
    },
    cancel() {
      this.$parent.componentName = '';
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style lang="scss" scoped>
.colorBlock {
  font-size: 20px;
  line-height: 25px;
  display: flex;
  font-weight: bold;
}
.colorBlock::before {
  content: '';
  width: 10px;
  height: 25px;
  background: blue;
  margin-right: 5px;
  display: inline-block;
}
.chartDia >>> .el-form-item {
  margin-bottom: 10px;
}
</style>
